import { AuditEntry } from "slot-definitions"
import { getAuditPayload } from "routes/audit/controller/get-audits-by-reference-id"
import { IconButton } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { navigate } from "lib/routes/navigate"
import { useMobile } from "lib/@components/mobile"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

AuditEntry("customSchedule").plug(<ShowInfo />)

function ShowInfo({ id, referenceId }) {
    const payload = getAuditPayload.useResults(id)
    const [scheduleId] = referenceId.split("-version:")
    const isMobile = useMobile()
    const { ok, setOpen } = useBoundContext()

    return (
        !!payload?.previous && (
            <IconButton aria-label="Compare versions" color="primary" size="small" onClick={goToCompare}>
                <Iconify icon="ic:outline-remove-red-eye" />
            </IconButton>
        )
    )

    function goToCompare() {
        navigate(
            `/app/schedules/compare/scheduleHistory!${scheduleId}-${payload.previous}/audit!${id}?right=Review Version&left=Previously Published Version`
        )
        if (isMobile) {
            ok()
            setOpen(false)
        }
    }
}
